module.exports = __webpack_public_path__ + "static/assets/7f32e637fbc8548b7bd30ec6813110dd.svg";